/* NOVA Solution — homepage (hi-fi port) interactions
   Growth-engine SVG, animated counters, scroll reveals. Vanilla, scoped, guarded. */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var NS = "http://www.w3.org/2000/svg";

  /* ---------- growth engine ---------- */
  function buildEngine(svgEl) {
    if (!svgEl || svgEl.dataset.built) return;
    svgEl.dataset.built = "1";
    var cx = 300, cy = 300, R = 212;
    var mods = ["Shopify", "CRO", "Paid Ads", "Retention", "SEO", "AI", "Analytics"];
    try { if (svgEl.dataset.modules) mods = JSON.parse(svgEl.dataset.modules); } catch (e) {}
    function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) { e.setAttribute(k, a[k]); } return e; }

    var defs = el("defs", {});
    var grad = el("radialGradient", { id: "nv-core-g", cx: "50%", cy: "42%", r: "70%" });
    grad.appendChild(el("stop", { offset: "0%", "stop-color": "#1f1c19" }));
    grad.appendChild(el("stop", { offset: "100%", "stop-color": "#0c0a08" }));
    defs.appendChild(grad);
    var f = el("filter", { id: "nv-soft", x: "-40%", y: "-40%", width: "180%", height: "180%" });
    f.appendChild(el("feGaussianBlur", { stdDeviation: "2.4" }));
    defs.appendChild(f);
    svgEl.appendChild(defs);

    var ringG = el("g", {});
    ringG.appendChild(el("circle", { cx: cx, cy: cy, r: 262, fill: "none", stroke: "#E7E1D4", "stroke-width": "1", "stroke-dasharray": "2 9" }));
    if (!reduce) ringG.appendChild(el("animateTransform", { attributeName: "transform", type: "rotate", from: "0 " + cx + " " + cy, to: "360 " + cx + " " + cy, dur: "90s", repeatCount: "indefinite" }));
    svgEl.appendChild(ringG);
    svgEl.appendChild(el("circle", { cx: cx, cy: cy, r: R, fill: "none", stroke: "#E7E1D4", "stroke-width": "1" }));

    var pts = mods.map(function (m, i) {
      var ang = (-90 + i * 360 / mods.length) * Math.PI / 180;
      return { l: m, x: cx + R * Math.cos(ang), y: cy + R * Math.sin(ang) };
    });

    pts.forEach(function (p, i) {
      var d = "M " + p.x.toFixed(1) + " " + p.y.toFixed(1) + " L " + cx + " " + cy;
      svgEl.appendChild(el("path", { d: d, fill: "none", stroke: "#E2DBCB", "stroke-width": "1" }));
      var pid = "nv-flow-" + i;
      svgEl.appendChild(el("path", { id: pid, d: d, fill: "none", stroke: "none" }));
      if (!reduce) {
        var dot = el("circle", { r: 2.6, fill: "#DF823C", filter: "url(#nv-soft)" });
        var am = el("animateMotion", { dur: "2.6s", begin: (i * 0.34) + "s", repeatCount: "indefinite", keyPoints: "0;1", keyTimes: "0;1", calcMode: "linear" });
        var mp = el("mpath", {}); mp.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + pid); mp.setAttribute("href", "#" + pid);
        am.appendChild(mp); dot.appendChild(am); svgEl.appendChild(dot);
      }
    });

    pts.forEach(function (p) {
      var w = p.l.length * 7.4 + 30, h = 34;
      var g = el("g", {});
      g.appendChild(el("rect", { x: p.x - w / 2, y: p.y - h / 2, width: w, height: h, rx: 17, fill: "#FFFFFF", stroke: "#D9D2C2", "stroke-width": "1" }));
      var t = el("text", { x: p.x, y: p.y + 4.5, "text-anchor": "middle", fill: "#15140F", "font-size": "13", "font-family": "Hanken Grotesk, sans-serif", "font-weight": "500" });
      t.textContent = p.l; g.appendChild(t); svgEl.appendChild(g);
    });

    svgEl.appendChild(el("circle", { cx: cx, cy: cy, r: 70, fill: "none", stroke: "#DF823C", "stroke-width": "1", opacity: "0.4" }));
    if (!reduce) {
      var pulse = el("circle", { cx: cx, cy: cy, r: 70, fill: "none", stroke: "#DF823C", "stroke-width": "1" });
      pulse.appendChild(el("animate", { attributeName: "r", values: "70;92;70", dur: "3.4s", repeatCount: "indefinite" }));
      pulse.appendChild(el("animate", { attributeName: "opacity", values: "0.5;0;0.5", dur: "3.4s", repeatCount: "indefinite" }));
      svgEl.appendChild(pulse);
    }
    svgEl.appendChild(el("circle", { cx: cx, cy: cy, r: 64, fill: "url(#nv-core-g)", stroke: "#2a2622", "stroke-width": "1" }));
    var ct = el("text", { x: cx, y: cy - 2, "text-anchor": "middle", fill: "#FFFDF9", "font-size": "26", "font-family": "Hanken Grotesk, sans-serif", "font-weight": "700", "letter-spacing": "1" });
    ct.textContent = svgEl.dataset.core || "NOVA"; svgEl.appendChild(ct);
    var cs = el("text", { x: cx, y: cy + 18, "text-anchor": "middle", fill: "#B7AF9F", "font-size": "9.5", "font-family": "JetBrains Mono, monospace", "letter-spacing": "2" });
    cs.textContent = "GROWTH ENGINE"; svgEl.appendChild(cs);
  }

  /* ---------- counters ---------- */
  function animateCount(node) {
    if (node.dataset.done) return; node.dataset.done = "1";
    var target = parseFloat(node.dataset.count), pre = node.dataset.prefix || "", suf = node.dataset.suffix || "";
    if (reduce) { node.textContent = pre + target + suf; return; }
    var start = performance.now(), dur = 1300;
    (function tick(now) {
      var t = Math.min((now - start) / dur, 1), eased = 1 - Math.pow(1 - t, 3);
      node.textContent = pre + Math.round(target * eased) + suf;
      if (t < 1) requestAnimationFrame(tick);
    })(start);
  }

  /* ---------- reveals + counters on scroll ---------- */
  function initScope(root) {
    root = root || document;
    root.querySelectorAll(".nv-scope #nv-engineSvg, .nv-scope svg[data-engine]").forEach(buildEngine);

    var rvEls = [].slice.call(root.querySelectorAll(".nv-scope .nv-rv:not(.nv-seen)"));
    var foldH = window.innerHeight || document.documentElement.clientHeight;
    rvEls.forEach(function (el, i) {
      el.classList.add("nv-seen");
      if (el.getBoundingClientRect().top > foldH * 0.92) {
        el.classList.add("nv-hide");
        el.style.transitionDelay = (Math.min(i % 5, 4) * 0.06) + "s";
      }
    });

    function onScroll() {
      var h = window.innerHeight || document.documentElement.clientHeight;
      document.querySelectorAll(".nv-scope .nv-rv.nv-hide:not(.nv-in)").forEach(function (el) {
        if (el.getBoundingClientRect().top < h * 0.9) el.classList.add("nv-in");
      });
      document.querySelectorAll(".nv-scope [data-count]").forEach(function (n) {
        if (!n.dataset.done && n.getBoundingClientRect().top < h * 0.85) animateCount(n);
      });
    }
    if (!window.__nvBound) {
      window.__nvBound = 1;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
    }
    onScroll();
    requestAnimationFrame(onScroll);
    setTimeout(onScroll, 300);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initScope(document); });
  else initScope(document);
  document.addEventListener("shopify:section:load", function (e) { initScope(e.target); });
})();
